import type { TourStep } from "../tour-steps";
import { CONFIGURACOES, MINHA_CLINICA, ajudaFinal, area, boasVindas } from "./passos";

/** Clínica com laboratório próprio: o ciclo inteiro dentro da mesma organização — paciente,
 *  consulta, pedido ao próprio laboratório, produção e o dinheiro. */
export const tourDaHibrida = (c: boolean): TourStep[] => [
  boasVindas(
    "Clínica e laboratório no mesmo lugar",
    "Sua organização atende pacientes e produz próteses. Este tour mostra o caminho completo: do paciente na cadeira ao trabalho pronto no seu próprio laboratório.",
  ),
  area(c, {
    id: "pacientes",
    menu: "sidebar-pacientes",
    noCelular: "toque em Menu, na barra de baixo, e depois em Pacientes",
    nome: "Pacientes",
    titulo: "1. O paciente",
    texto: "Tudo começa na ficha do paciente: dados, anamnese, odontograma e o plano de tratamento com os preços do seu catálogo.",
  }),
  area(c, {
    id: "agenda",
    menu: "sidebar-agenda",
    aba: "aba-agenda",
    nome: "Agenda",
    titulo: "2. A consulta",
    texto: "Marque e acompanhe os atendimentos da clínica por dia, semana ou mês, filtrando por profissional.",
  }),
  area(c, {
    id: "protese",
    menu: "sidebar-protese",
    nome: "Prótese",
    titulo: "3. O pedido ao seu laboratório",
    texto: "Na Prótese (ou direto do plano de tratamento), peça o trabalho escolhendo o seu próprio laboratório — ou um parceiro de fora, se preferir.",
  }),
  area(c, {
    id: "pedidos",
    menu: "sidebar-pedidos",
    aba: "aba-pedidos",
    nome: "Pedidos",
    titulo: "4. O pedido chega no laboratório",
    texto: "O pedido da sua clínica aparece aqui, junto com os das clínicas parceiras. Aceite para mandar à produção.",
  }),
  area(c, {
    id: "producao",
    menu: "sidebar-producao",
    nome: "Produção",
    titulo: "5. A produção",
    texto: "Cada serviço avança pelos estágios até ser finalizado. A clínica vê o andamento no pedido, sem precisar perguntar.",
  }),
  area(c, {
    id: "catalogo",
    menu: "sidebar-catalogo",
    nome: "Catálogo",
    titulo: "Dois catálogos",
    texto: "O Catálogo do laboratório tem os serviços de prótese e os preços para clínicas; os procedimentos da clínica (consultas, restaurações) ficam em Procedimentos.",
  }),
  area(c, {
    id: "financeiro",
    menu: "sidebar-financeiro",
    nome: "Financeiro",
    titulo: "O dinheiro",
    texto: "A receber, a pagar e o resultado do mês. Os trabalhos concluídos para clínicas parceiras já entram como cobrança.",
  }),
  MINHA_CLINICA(c),
  CONFIGURACOES(c),
  ajudaFinal(),
];
